import React, { useMemo } from 'react'
import TalentPlaylistsService from './Service'
import { useServiceState } from 'helpers'

import { ITalentPlaylistsProviderProps } from './Interfaces'

import SessionManagerService from '../session-manager/Service'

const Provider: React.FC<ITalentPlaylistsProviderProps> = ({ children, onClickPlaylist }) => {
  const sessionManagerState = useServiceState(SessionManagerService, false)

  const playlists = useMemo(() => {
    if (sessionManagerState.currentUser) {
      return TalentPlaylistsService.parseUserPlaylists(sessionManagerState.currentUser.playlists)
    }
    return []
  }, [sessionManagerState.currentUser])

  return (
    <React.Fragment>
      {children({
        playlists,
        onClickPlaylist
      })}
    </React.Fragment>
  )
}

export default Provider
